var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ns-button",
    {
      staticClass: "btn btn-primary",
      class: _vm.chatType,
      attrs: { id: "quiq-chat-button", disabled: _vm.disabled, href: _vm.href },
      on: { click: _vm.startChat },
    },
    [_vm._v(_vm._s(_vm.buttonDisplayName))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }